import styles from './ProjectProtocolsTableCell.module.css'

const ProjectProtocolsTableCell = ({ id, canGrow, basicWidth, component }) => {
	return (
		<div className={styles.cell_wrapper} style={{ flexGrow: canGrow ? '1' : '0', width: basicWidth }}>
			{component}
		</div>
	)
}

export default ProjectProtocolsTableCell
